// extracted by mini-css-extract-plugin
module.exports = {"brandColor":"SectionText_brandColor__nW4oj","noBackgroundColor":"SectionText_noBackgroundColor__NI6WW","group":"SectionText_group__QYVHH"};